export const formTypes = {
  STRING: 'string',
  NUMBER: 'number',
  CHECKBOX: 'checkbox',
  SELECT: 'select',
  IMAGE: 'image',
  ARRAY: 'array',
  OBJECT: 'object',
  DYNAMIC_OBJECT: 'dynamicObject',
  JSON_STRING: 'jsonString'
};

export const removeButtonPosition = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const fieldsDirection = {
  ROW: 'row',
};

export type RemoveButtonPositionTypes =
  typeof removeButtonPosition[keyof typeof removeButtonPosition];

export type FormTypes =
  typeof formTypes[keyof typeof formTypes];

export type FieldsDirectionTypes =
  typeof fieldsDirection[keyof typeof fieldsDirection];
